import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { AccountDetail, AccountAppAccess, AccountPlacement } from '@/api/accounts';
import cells from '../accountsCells.module.css';
import styles from './accountProfile.module.css';

interface Props {
    detail: AccountDetail;
}

/**
 * EAA-1820 (frame 72, tab Quyền theo đơn vị): every active placement plus
 * per-application roles resolved server-side — the fields the list row cannot carry.
 */
export function AccountProfilePermissionsTab({ detail }: Props) {
    const { t } = useTranslation();

    return (
        <div className={styles.permissions}>
            <section className={styles.card}>
                <h2 className={styles.cardTitle}>{t('console.accounts.profile.permissionsPlacementsTitle')}</h2>
                {detail.placements.length === 0 ? (
                    <p className={cells.unassigned}>{t('console.accounts.detailDrawer.placementUnassigned')}</p>
                ) : (
                    <ul className={styles.permList}>
                        {detail.placements.map((p: AccountPlacement) => (
                            <li key={p.organization_id + p.level_name} className={styles.permRow}>
                                <div>
                                    <strong>{p.organization_name}</strong>
                                    {p.level_name && (
                                        <span className="acc-profile-perm-level"> · {p.level_name}</span>
                                    )}
                                </div>
                                {p.role_key && <code className={cells.approle}>{p.role_key}</code>}
                            </li>
                        ))}
                    </ul>
                )}
            </section>

            <section className={styles.card}>
                <h2 className={styles.cardTitle}>{t('console.accounts.detailDrawer.appAccessLabel')}</h2>
                {detail.app_access.length === 0 ? (
                    <p className={cells.unassigned}>{t('console.accounts.detailDrawer.noPermission')}</p>
                ) : (
                    <ul className={styles.appList}>
                        {detail.app_access.map((app: AccountAppAccess) => (
                            <li key={app.application} className={styles.appRow}>
                                <div className={styles.appRowHead}>
                                    <strong>{app.application_name}</strong>
                                    <span className={styles.appCode}>{app.application}</span>
                                </div>
                                <div className={styles.appRoles}>
                                    {app.roles.map((role) => (
                                        <code className={cells.approle} key={role}>
                                            {role}
                                        </code>
                                    ))}
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </section>

            {detail.placements.length > 0 && (
                <p className={`portal-admin-hint ${styles.permHint}`}>
                    {t('console.accounts.profile.permissionsHint')}{' '}
                    <Link to="/console/role-map">{t('console.accounts.profile.roleMapLink')}</Link>
                </p>
            )}
        </div>
    );
}

export default AccountProfilePermissionsTab;
